import React from 'react';
import { Table, Button } from 'react-bootstrap';
import { CiGlobe } from "react-icons/ci";

const DynamicTableStores = ({ topStoresReport, setSelectedStore }) => {

    const styleButton = {
        background: "#f3f3f3",
        outline: "none",
        cursor: "pointer",
        padding: 4,
        display: "inline-flex",
        border: "none",
        borderRadius: "50%",
        boxShadow: "1px 1px 2px 0px rgb(0 0 0 / .3)"
    };

    return (
        <Table size="sm" striped bordered hover style={{ borderColor: 'lightgreen' }}>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Total</th>
                    <th>Detail</th>
                    <th>Path</th>
                </tr>
            </thead>
            <tbody>
                {topStoresReport.map(store => (
                    <tr key={store._id}>
                        <td>{store.nameStore}</td>
                        <td> $ {store.totalSales.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        <td><Button size='sm' onClick={() => setSelectedStore(store)}>View</Button></td>
                        <td align='center'>
                            <button
                                title="Open Path"
                                style={styleButton}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    window.open('https://' + store.pathStore, '_blank', 'noreferrer');
                                }}
                            >
                                <CiGlobe color="blue" />
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default DynamicTableStores;